<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal :visible="financialItemChargeModalShow" :data="model"
                   :title="computedTitle" @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')" :is-loading="loading"
                   scrollable>
      <input-widget :autofocus="true" :model="model" attribute="amount" type="number"/>
      <input-widget attribute="taxable" :model="model" type="checkbox"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import FinancialItemChargeModal from "@/modules/customer/models/FinancialItemChargeModal";
  import _ from "lodash";

  const {mapState, mapActions} = createNamespacedHelpers('reservations');

  export default {
    name: "FinancialItemChargeModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new FinancialItemChargeModal({}),
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['hideFinancialItemChargeModal', 'saveFinancialItemCharge']),
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t('Changing charge amount will trigger automatic recalculation of all associated invoices and settlements. Would you like to proceed?'));
        if (!success) {
          return
        }

        this.loading = true;
        let response = await this.saveFinancialItemCharge({
          amount: this.model.amount,
          taxable: this.model.taxable,
          uuid: this.model.uuid,
        });
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          await this.hideFinancialItemChargeModal(false);
          this.$toast('success', this.$t('Charge was successfully updated'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new FinancialItemChargeModal();
        this.hideFinancialItemChargeModal(false);
      },
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {
          this.model = new FinancialItemChargeModal(_.cloneDeep(this.editObject));
          this.model.taxable = this.editObject.vat > 0
        }
      }
    },
    computed: {
      ...mapState({
        financialItemChargeModalShow: state => state.view.termsData.financialItemChargeModal.show,
        editObject: state => state.view.termsData.financialItemChargeModal.object
      }),
      computedTitle() {
        if (this.model.uuid) {
          return this.$i18n.t("Edit Charge")
        }
        return this.$i18n.t("Create Charge")
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>

